import { Fragment } from "react";
import { Info } from "lucide-react";
import { useSilver } from "@/context/SilverContext";
import { describeLogic } from "@/data/presets";

export function LogicSummary({ compact = false }) {
  const { filters, audience, setHowOpen } = useSilver();
  const parts = describeLogic(filters);
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-2" data-testid="audience-logic-summary">
      {!compact && <span className="eyebrow-muted">Matching rule</span>}
      {parts.map((p, i) => (
        <Fragment key={p.text}>
          {i > 0 && <span className="font-ui text-[10px] font-bold tracking-[0.14em] text-[#C6EE5A]">AND</span>}
          <span className="rounded-full border border-white/10 bg-white/[0.04] px-3 py-1 font-ui text-[12px] text-white/85">
            {p.group && parts.length > 1 ? `( ${p.text} )` : p.text}
          </span>
        </Fragment>
      ))}
      <span className="font-ui text-[12px] text-white/45">
        {audience.matchedProfiles} of {audience.profileCount} profiles
      </span>
      <button type="button" onClick={() => setHowOpen(true)} className="inline-flex items-center gap-1.5 text-[12px] text-white/55 underline-offset-4 hover:text-white hover:underline" data-testid="how-calculated-btn">
        <Info className="h-3.5 w-3.5" /> How is this calculated?
      </button>
    </div>
  );
}
